/**
 * O nome do mapa que vem do banco, para a chave de tradução.
 *
 * O V2 devolve `maps.name` como texto — "Píer", "Rio Amazonas" — e o i18n
 * indexa por chave curta (`pier`, `amazonRiver`). Alguém tem que fazer a ponte.
 *
 * Isto morava copiado em `CartaNautica.vue`, `FishMarket.vue` e
 * `EmployeeMapAssignmentModal.vue`, com as três listas iguais por sorte. É o
 * mesmo risco que fez `luck` valer 7,5 no backend e 4,5 aqui: mapa novo no
 * catálogo entraria numa cópia e não nas outras, e o sintoma seria o nome cru
 * aparecendo numa tela só.
 *
 * As duas grafias (português e inglês) continuam aceitas porque o catálogo
 * herdado do Strapi tem as duas, dependendo de quando a linha foi criada.
 */
const CHAVES = {
  Píer: 'pier',
  Praia: 'beach',
  Lago: 'lake',
  'Rio Amazonas': 'amazonRiver',
  'Mar Aberto': 'openSea',
  'Ilhas Cazu': 'cazuIslands',
  'Costa Dourada': 'goldenCoast',

  Pier: 'pier',
  Beach: 'beach',
  Lake: 'lake',
  'Amazon River': 'amazonRiver',
  'Open Sea': 'openSea',
  'Cazu Islands': 'cazuIslands',
  'Golden Coast': 'goldenCoast',
};

/**
 * Nome desconhecido cai no próprio nome em minúsculas — que quase certamente
 * não existe no i18n, e o `$t` devolve a chave. É de propósito: mapa novo
 * aparece com o nome errado na tela, e não some dela.
 */
export function getMapKey(mapName) {
  if (!mapName) return '';
  return CHAVES[mapName] || String(mapName).toLowerCase();
}

export default getMapKey;
